import {useEffect} from 'react'
import {useAuth} from './core/Auth'

import {getAuth, signOut} from 'firebase/auth'

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    const auth = getAuth()
    signOut(auth)
    logout()
    window.location.href = '/auth/login'
  }, [logout])

  return <></>
}
